import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const RHONavListInternal: MenuItem[] = [
    {
        id: 1,
        name: 'summaryReview',
        componentName: 'Summary',
        complete: false,
        icon: faFilePdf
    },
    {
        id: 2,
        name: 'contactInfo',
        componentName: 'ContactInfo',
        complete: false
    },
    {
        id: 3,
        name: 'incomeExpense',
        componentName: 'IncomeExpense',
        complete: false,
        icon: faMoneyBillTrendUp,
        subItems: [
            {
                id: 31,
                name: 'occupancyStats',
                componentName: 'OccupancyStatistics',
                complete: false
            },
            {
                id: 32,
                name: 'revenue',
                complete: false,
                hasTabs: true,
                componentName: 'RevenueContainer',
                subItems: [
                    {
                        id: 321,
                        name: 'operatingRevenue',
                        complete: false,
                    },
                    {
                        id: 322,
                        name: 'nonOperatingIncomeRevenues',
                        complete: false,
                    }
                ]
            },
            {
                id: 33,
                name: 'expenses',
                componentName: 'ExpenseContainer',
                hasTabs: true,
                complete: false,
                subItems: [
                    {
                        id: 331,
                        name: 'expenses',
                        complete: false
                    },
                    {
                        id: 332,
                        name: 'managementFees',
                        complete: false
                    },
                    {
                        id: 333,
                        name: 'fixedCharges',
                        complete: false
                    },
                    {
                        id: 334,
                        name: 'nonOperatingIncomeExpenses',
                        complete: false
                    }
                ]
            },
            {
                id: 34,
                name: 'reserveForReplacementAllowance',
                componentName: 'ReserveForReplacementAllowance',
                complete: false,
            },
            {
                id: 35,
                name: 'capitalExpSummary',
                complete: false,
                componentName: 'CapitalCostsSummary'
            },
            {
                id: 36,
                name: 'analysis',
                componentName: 'Analysis',
                complete: false
            }
        ],
    },
    {
        id: 4,
        name: 'residential',
        complete: false,
        icon: faBuilding,
        subItems: [
            {
                id: 41,
                name: 'independentLiving',
                complete: false,
                componentName: 'IndependentLiving'
            },
            {
                id: 42,
                name: 'assistedLiving',
                complete: false,
                componentName: 'AssistedLiving'
            },
            {
                id: 43,
                name: 'memoryCare',
                complete: false,
                componentName: 'MemoryCare'
            },
            {
                id: 44,
                name: 'residentialParking',
                componentName: 'ResidentialParking',
                complete: false,
            },
        ]
    },
    {
        id: 5,
        name: 'commercial',
        icon: faCartShopping,
        complete: false,
        subItems: [
            {
                id: 51,
                name: 'leaseInformationTable',
                componentName: 'LeaseInfo',
                complete: false,
            },
            {
                id: 52,
                name: 'vacantAskingRate',
                complete: false,
                componentName: 'VacantAskingRate',
            },
            {
                id: 53,
                name: 'parkingSummary',
                complete: false,
                componentName: 'ParkingPropertySummary',
            }
        ]
    },
    {
        id: 6,
        name: 'comments',
        componentName: 'Comment',
        complete: false
    },
    {
        id: 7,
        name: 'submit',
        componentName: 'Submit',
        complete: false,
        icon: faFileInvoiceDollar
    }
]

export default RHONavListInternal